"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M11.763 1.124c.1-.165.34-.165.44 0l1.907 3.183a.256.256 0 0 0 .3.11l1.507-.5a.256.256 0 0 1 .331.299L15.03 9.67c-.111.5.5.836.862.474l2.803-2.806a.257.257 0 0 1 .425.101l.515 1.573c.042.127.175.2.305.168l2.054-.512a.256.256 0 0 1 .291.362l-.997 2a.255.255 0 0 0 .128.349l1.429.61c.18.078.21.322.053.44l-5.493 4.12a.257.257 0 0 0-.088.287l.537 1.604a.26.26 0 0 1-.294.336c-.862-.164-2.7-.515-4.403-.628V22a.998.998 0 0 1-.96.998c-.007 0-.014.003-.022.003L12.168 23h-.01a1 1 0 0 1-1-1v-3.862c-1.737.094-3.766.467-4.664.64a.259.259 0 0 1-.294-.337l.52-1.554a.256.256 0 0 0-.09-.285L1.103 12.46a.256.256 0 0 1 .072-.448l1.44-.477a.256.256 0 0 0 .149-.357L1.692 9.025a.256.256 0 0 1 .29-.362l2.047.51a.256.256 0 0 0 .305-.168l.517-1.563a.256.256 0 0 1 .424-.1l2.808 2.817c.362.363.973.027.86-.474l-1.23-5.461a.256.256 0 0 1 .332-.3l1.491.506a.256.256 0 0 0 .302-.11l1.925-3.196Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};